import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesQuotationService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  createFormData(salesQuotation: any): FormData {
    // // debugger;
    if (salesQuotation.transactionDate && typeof salesQuotation.transactionDate !== 'string') {
      salesQuotation.transactionDate = (new Date(salesQuotation.transactionDate)).toISOString();
    }

    const formData = new FormData();
    formData.append('customerId', salesQuotation.customerId.toString()),
    formData.append('customerNote', salesQuotation.customerNote),
      formData.append('factoryId', salesQuotation.factoryId.toString()),
      formData.append('salesManId', salesQuotation.salesManId),
      formData.append('status', salesQuotation.status.toString()),
      formData.append('notes', salesQuotation.notes?.toString() || ''),
      formData.append('parentSalesQuotationId', salesQuotation.parentSalesQuotationId?salesQuotation.parentSalesQuotationId.toString():'0'),
      formData.append(
        'transactionDate',
        salesQuotation.transactionDate),
        formData.append('isFactoryDelivery', salesQuotation.fromFactory.toString()),
      formData.append('total', salesQuotation.total.toString()),
      formData.append(
        'totalBeforeVAT',
        salesQuotation.totalBeforeVAT.toString()
      ),
      formData.append('vatAmount', salesQuotation.vatAmount.toString()),
      formData.append('vatPercentage', salesQuotation.vatPercentage.toString()),
      formData.append('id', salesQuotation.id.toString()),
      salesQuotation.customerAddressList.forEach((line,index)=>{
        formData.append(`CustomerAddresses[${index}]`, line.id.toString());
      })
      salesQuotation.salesQuotationLines.forEach((line, index) => {
        formData.append(`salesQuotationLines[${index}].id`, line.id.toString());
        formData.append(
          `salesQuotationLines[${index}].itemId`,
          line.itemId.toString()
        );
        formData.append(
          `salesQuotationLines[${index}].quantity`,
          line.quantity.toString()
        );
        formData.append(
          `salesQuotationLines[${index}].total`,
          line.total.toString()
        );
        formData.append(
          `salesQuotationLines[${index}].unitPrice`,
          line.unitPrice.toString()
        );
        formData.append(
          `salesQuotationLines[${index}].unitPriceWithTax`,
          line.unitPriceWithTax.toString()
        );
        formData.append(`salesQuotationLines[${index}].uom`, line.uom);
        formData.append(
          `salesQuotationLines[${index}].vatAmount`,
          line.vatAmount.toString()
        );
        formData.append(
          `salesQuotationLines[${index}].vatPercentage`,
          line.vatPercentage.toString()
        );
      });

    salesQuotation.documentAttachments.forEach((line, index) => {
      formData.append(
        `documentAttachments[${index}].id`,
        line.id
      );
      formData.append(
        `documentAttachments[${index}].fileContent`,
        line.fileContent
      );
      formData.append(`documentAttachments[${index}].filename`, line.filename);
      formData.append(`documentAttachments[${index}].path`, line.path);
    });
    

    salesQuotation.validationCheckBoxes.forEach((line,index)=>{
      formData.append(`priceInfoList[${index}]`, line.toString());
    });
    
    if(salesQuotation.salesQuotationLines.length==0){
      formData.append('salesQuotationLines', JSON.stringify([]));
    }

    if(salesQuotation.documentAttachments.length==0){
      formData.append('documentAttachments', JSON.stringify([]));
    }

    // if(salesQuotation.customerAddressList.length==0){
    //   formData.append('CustomerAddresses', JSON.stringify([]));
    // }

    return formData;
  }
  getAllSalesQuotations() {
    return this.http.get<any>(`${this._baseUrl}/SalesQuotation`);
  }

  getPaginatedSalesQuotations(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/SalesQuotation/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  getSalesQuotationById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/SalesQuotation/${id}`);
  }

  deleteSalesQuotation(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/SalesQuotation/${id}`);
  }

  addNewSalesQuotation(salesQuotation: any) {

    const formData = this.createFormData(salesQuotation);
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    return this.http.post<any>(`${this._baseUrl}/SalesQuotation/Add`, formData);
  }

  updateSalesQuotation(id: number, salesQuotation: any) {
    const formData = this.createFormData(salesQuotation);
    return this.http.patch<any>(
      `${this._baseUrl}/SalesQuotation/${id}`,
      formData
    );
  }

  printSalesQuotation(id: number) {
    return this.http.get<any>(`${this._baseUrl}/report/Customer/QuotationDetailsReport?quotationid=${id}`);
  }
}
